import { isFeatureEnabled } from 'owa-feature-flags';
import { getPalette } from 'owa-theme';

/*
 * If mon-ribbon-toolbar-color is not enabled, all icons should be palette.black
 * (except the hero button).  Otherwise, return 'undefined', and the code
 * will determine icon color from the RibbonId
 */

export const getToolbarRibbonIconColor = (): string | undefined => {
    return !isFeatureEnabled('mon-ribbon-toolbar-color') ? getPalette().black : undefined;
};
